module.exports = __webpack_public_path__ + "static/about-1-d7c00c8b3af4284e12d2e6716198ed85.jpg";